import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Sticky from 'react-stickynode';
import logo from "../../../assets/images/logo_horizental.jpg";
import { animateScroll } from 'react-scroll';
import { Dropdown } from 'semantic-ui-react'
import './Header.css'
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { I18nextProvider } from "react-i18next";

import fr from '../../../assets/traduction/fr.json';
import en from '../../../assets/traduction/en.json';
import tn from '../../../assets/traduction/tn.json';

i18next.init({
    interpolation: { escapeValue: false },  // React already does escaping
    init: 'en',
    lng: 'en',                              // language to use,
    resources: {
        en: {
            traduction: en               // 'common' is our custom namespace
        },
        fr: {
            traduction: fr
        },
        tn: {
            traduction: tn
        },
    },
});

var countryOptions = [
    { key: 'fr', value: 'fr', flag: 'fr', text: 'Français' },
    { key: 'en', value: 'en', flag: 'uk', text: 'English ' },
    { key: 'tn', value: 'tn', flag: 'tn', text: 'Arabic  ' },
]
const Header = (props) => {
    function handleChange(e) {
        if (e.target.innerText === "English") {
            props.SetLang("en")
        }
        else if (e.target.innerText === "Français") {
            props.SetLang("fr")
        }
        else if (e.target.innerText === "Arabic") {
            props.SetLang("tn")

        }
    }

    function scrollToTop() {
        animateScroll.scrollToTop();
    }
    const [t, i18n] = useTranslation('traduction');

    useEffect(() => {

        // sidebar open/close
        var btn = document.querySelector('.navicon');
        var nav = document.querySelector('.header-nav');

        function toggleFunc() {
            btn.classList.toggle("open");
            nav.classList.toggle("show");
        }

        btn.addEventListener('click', toggleFunc);


        // Sidenav li open close
        var navUl = [].slice.call(document.querySelectorAll('.header-nav > ul > li'));
        for (var y = 0; y < navUl.length; y++) {
            navUl[y].addEventListener('click', function () { checkLi(this) });
        }

        function checkLi(current) {
            const active = current.classList.contains("open")
            navUl.forEach(el => el.classList.remove('open'));
            //current.classList.add('open');

            if (active) {
                current.classList.remove('open')
            } else {
                current.classList.add('open');
            }
        }
        i18n.changeLanguage(props.lang);

    }, [i18n, props.lang]);

    return (
        <>
            <I18nextProvider i18n={i18next}>
                <header class="site-header mo-left header">
                    <Sticky innerZ={999} enabled={true}>
                        <div class="sticky-header main-bar-wraper navbar-expand-lg">
                            <div class="main-bar clearfix ">
                                <div class="container clearfix">

                                    <div class="logo-header mostion">
                                        <Link to={'/'}><img src={logo} alt="" /></Link>
                                    </div>

                                    <button class="navbar-toggler navicon justify-content-end" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </button>


                                    <div class={`header-nav navbar-collapse collapse justify-content-end`} id="navbarNavDropdown">
                                        <div class="logo-header d-md-block d-lg-none">
                                            <Link to={'/'}><img src="" alt="" /></Link>
                                        </div>
                                        <ul class="nav navbar-nav">
                                            <li class=""> <NavLink exact to='/' onClick={scrollToTop()} activeClassName="selected" >
                                                {t('Accueil')}<i class="fa "></i>
                                            </NavLink>
                                            </li>
                                            <li class="has-mega-menu"> <NavLink to='/presentation' onClick={scrollToTop()} activeClassName="selected" >
                                                {t('Présentation')}<i class="fa "></i>
                                            </NavLink>                                            </li>

                                            <li>
                                                <NavLink to='/produits' onClick={scrollToTop()} activeClassName="selected" >
                                                    {t('Produits')}<i class="fa "></i>
                                                </NavLink>
                                                <ul class="sub-menu">
                                                    <li><Link to={'/Produits/viande'}> {t('Viande et Volaille')}</Link></li>
                                                    <li><Link to={'/Produits/poisson'}> {t('Poisson')}</Link></li>
                                                    <li><Link to={'/Produits/charcuterie'}> {t('Saucisse et Fromage')}</Link></li>
                                                    <li><Link to={'/Produits/fruits'}> {t('Fruits et Légumes')}</Link></li>
                                                    <li><Link to={'/Produits/oeufs'}> {t('Oeufs')}</Link></li>
                                                    <li><Link to={'/Produits/dattes'}> {t('Dattes')}</Link></li>
                                                </ul>
                                            </li>
                                            <li class="has-mega-menu"> <NavLink to='/reference' onClick={scrollToTop()} activeClassName="selected" >
                                                {t('Nos Références')} <i class="fa "></i>
                                            </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to='/contact' onClick={scrollToTop()} activeClassName="selected" >
                                                    {t('Contactez-Nous')} <i class="fa "></i>
                                                </NavLink>

                                            </li>
                                            <li className="language-Dropdown">
                                                <Dropdown
                                                    placeholder='language'
                                                    fluid
                                                    selection
                                                    options={countryOptions}
                                                    defaultValue={props.lang}
                                                    onChange={event => handleChange(event)}
                                                />
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Sticky>

                </header>
            </I18nextProvider>
        </>
    )

}
export default Header;


